<template>
  <div class="company-user" v-loading="loading">
    <div class="title">
      <div style=" margin-top: 15px; margin-bottom: 10px">
        企业成员
      </div>
      <div class="tip" v-if="currentCompany.dingEnable">
        <template v-if="currentCompany.syncDing">
          <div>最后同步时间:{{ lastSyncDingUserTime }}</div>
          <base-button @click="syncDingUser">同步</base-button>
        </template>
        <base-button v-else @click="$router.push({ name: 'company-joint-setting' })">
          设置钉钉同步
        </base-button>
      </div>
    </div>
    <div class="main-wrap">
      <aside>
        <dpt-list ref="dptList" @select-dpt="handleSelectDpt" @change="refresh"></dpt-list>
      </aside>
      <main>
        <dpt-member ref="dptMember" @change="refresh"></dpt-member>
      </main>
    </div>
  </div>
</template>

<script>
import DptList from "./DptList"
import DptMember from "./DptMember"
import BaseButton from "@/components/UIComponents/Button"
import {
  getCompanyUsers,
  getCurCompany,
  getDepartmentTree,
  getLastSyncDingUserTime,
  syncDingUser,
  getCompanyRolesWithNum
} from "@/api/userCenter/company"

export default {
  name: "company-user",
  components: {
    DptList,
    DptMember,
    BaseButton
  },
  provide() {
    return {
      rootDepartment: this.company,
      curCompanyUsers: this.curCompanyUsers,
      currentCompany: this.currentCompany,
      roles: this.roles
    }
  },
  data() {
    return {
      currentCompany: { syncDing: false },
      company: {
        id: "",
        name: "",
        adminIds: "",
        children: "",
        companyId: "",
        createAt: ""
      },
      loading: true,
      lastSyncDingUserTime: "",
      curCompanyUsers: [],
      roles: []
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      Promise.all([
        getCurCompany().then(currentCompany => Object.assign(this.currentCompany, currentCompany)),
        getDepartmentTree({ noCache: true }).then(res => {
          Object.assign(this.company, res[0])
          this.convertDpt(this.company.children)
          this.$refs.dptList.init(this.company)
        }),
        getLastSyncDingUserTime().then(time => (this.lastSyncDingUserTime = time)),
        getCompanyUsers({ noCache: true, withLastReqTime: true }).then(res => {
          res.forEach(user => {
            user.status = user.companyScope?.gone ? "已停用" : user.lastReqTime ? "正常" : "未激活"
          })
          this.curCompanyUsers.length = 0
          this.curCompanyUsers.push(...res)
        }),
        getCompanyRolesWithNum().then(roles => {
          Object.assign(this.roles, roles)
        })
      ]).finally(() => (this.loading = false))
    },
    handleSelectDpt(dpt) {
      this.$refs.dptMember.selectDpt(dpt)
    },
    convertDpt(dptTree) {
      dptTree.forEach(dpt => {
        if (dpt.children?.length) this.convertDpt(dpt.children)
        else delete dpt.children
      })
    },
    syncDingUser() {
      syncDingUser().then(() => {
        this.$message.success("操作成功")
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.company-user {
  height: calc(100vh - 52px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin: -15px 0;
  .title {
    font-size: $font-size-title-first;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e4e4e4;
    display: flex;
    justify-content: space-between;
    .tip {
      font-size: 13px;
      display: flex;
      align-items: center;
      .base-button {
        margin-left: 10px;
      }
    }
  }
  .main-wrap {
    flex: 1 1;
    display: flex;
    height: 100%;
    overflow: hidden;
    aside {
      width: 195px;
      border-right: 1px solid #f5f7fa;
      flex-shrink: 0;
    }
    main {
      flex: 1 1;
      overflow: hidden;
    }
  }
  ::v-deep {
    .el-divider--horizontal {
      margin: 10px 0;
    }
  }
}
</style>
